var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import { colors } from "core/styles/snippets";
var Triangle = function (_a) {
    var className = _a.className, direction = _a.direction, color = _a.color;
    var _b = getDimensionsForDirection(direction), width = _b.width, height = _b.height, viewBox = _b.viewBox, transform = _b.transform;
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: width, height: height, viewBox: viewBox, className: className },
        React.createElement("path", { fill: getFill(color), d: "M9.9 0H.928a.927.927 0 00-.8 1.392L4.61 9.16a.929.929 0 001.608 0L10.7 1.392A.928.928 0 009.9 0z", transform: transform })));
};
export default Triangle;
function getFill(color) {
    switch (color) {
        case "blue":
            return "#0000ff";
        case "green":
            return "#00f200";
        case "pink":
            return "#ff00ff";
        case "primary":
            return colors.primary;
        case "white":
            return "#ffffff";
        case "black":
            return "#000000";
    }
}
function getDimensionsForDirection(direction) {
    var vertical = {
        width: "10.828",
        height: "9.623",
        viewBox: "0 0 10.828 9.623",
    };
    var horizontal = {
        width: "9.623",
        height: "10.828",
        viewBox: "0 0 9.623 10.828",
    };
    switch (direction) {
        case "up":
            return __assign(__assign({}, vertical), { transform: "rotate(180 5.414 4.811)" });
        case "right":
            return __assign(__assign({}, horizontal), { transform: "rotate(-90 5.414 5.414)" });
        case "down":
            return vertical;
        case "left":
            return __assign(__assign({}, horizontal), { transform: "rotate(90 4.811 4.812)" });
    }
}
